module.exports = __webpack_public_path__ + "static/filters-221cd3791320792ddbff9acf31367afe.png";